<template>
  <base-tooltip static-class="sidenav-context-select" v-model="isActive" trigger="click" placement="right-start">
    <base-button class="sidenav-context-select-btn" variant="primary" :icon-append="['fal', 'exchange']" tabindex="0" slot="reference">
      <div class="sidenav-context-select-btn__text" >
        <template v-if="context.isSelected('business')">
          <div class="sidenav-context-select-btn__title">{{ title }}</div>
          <div class="sidenav-context-select-btn__subtitle">{{ subtitle }}</div>
        </template>

        <template v-else>
          <div class="sidenav-context-select-btn__title">
            {{ $t('label.select{label}', { label: $t('label.context') }) }}
          </div>
        </template>
      </div>
    </base-button>

    <transition name="fade-transition">
      <context-select v-if="isActive" id="sidenav-context-select" :can-close="true" @close="onClose" :preferred-route="contextSelection.route"/>
    </transition>
  </base-tooltip>
</template>

<script>
import ContextSelect from '@/views/Context/Components/ContextSelect.vue'

import { context, menu } from '@/mixins/helpers'

export default {
  name: 'SideNavContextSelect',

  mixins: [ context, menu ],

  components: { ContextSelect },

  computed: {
    isActive: {
      get () {
        return this.contextSelection.isActive
      },
      set (value) {
        if (this.contextSelection.isActive !== value) {
          this.setContextSelectState({ isActive: value })
        }
      }
    },

    title () {
      return this.context.isSelected('business') ? this.context.business.title : ''
    },
    subtitle () {
      return this.context.isSelected('merchant') ? this.context.merchant.title : ''
    }
  },

  mounted () {
    this.$watch(() => this.isActive, isActive => {
      isActive ? document.body.classList.add('sidenav-context-select-open') : document.body.classList.remove('sidenav-context-select-open')
    })
  },

  methods: {
    onClose () {
      this.setContextSelectState({ isActive: false })
      this.$store.dispatch('setMinimumSelections')

      this.closeMenu()
    }
  }
}
</script>
